import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    iconActive: {
      color: palette.green,
      marginRight: 5,
      fontSize: 15,
    },
    iconCancel: {
      color: palette.red,
      marginRight: 5,
      fontSize: 15,
    },
    iconRemoveCircle: {
      color: palette.red,
      marginRight: 5,
      fontSize: 15,
    },
    iconContainer: {
      display: 'flex',
      gap: '5px',
    },
  });
